"use strict";
import { sha256 as sha256Lib } from "js-sha256";
import CryptoJS from "crypto-js";
import { ENCRYPTION_VERSION } from "./Constants";
import store from "@/store";

class EncryptionUtil {
  decodeJwt(token) {
    // JWT는 세 부분으로 나뉘며, 각 부분은 '.'으로 구분됩니다.
    const base64Url = token.split(".")[1]; // 페이로드 부분만 추출
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/"); // Base64Url을 Base64로 변환
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  }

  sha256() {
    const serviceCode = store.state.Auth.clientInfo.SERVICE_CODE;

    // SERVICE_CODE + ";" + ENCRYPTION_VERSION
    const combinedText = serviceCode + ";" + ENCRYPTION_VERSION;

    return sha256Lib(combinedText);
  }

  aes256Encrypt(text) {
    if (typeof text !== "string") {
      text = String(text ?? "");
    }

    const sha256Value = this.sha256();

    // sha256값의 앞 32자리를 key로 사용
    const key = sha256Value.substring(0, 32);
    // sha256값의 앞 16자리를 iv로 사용
    const iv = sha256Value.substring(0, 16);

    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

    const encrypted = CryptoJS.AES.encrypt(text, keyUtf8, {
      iv: ivUtf8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7 // Pkcs7은 Pkcs5와 동일한 패딩입니다
    });

    return encrypted.toString(); // Base64 문자열
  }

  aes256Decrypt(cipherText) {
    if (typeof cipherText !== "string") {
      throw new Error("cipherText는 문자열이어야 합니다.");
    }

    const sha256Value = this.sha256();

    // sha256값의 앞 32자리를 key로 사용
    const key = sha256Value.substring(0, 32);
    // sha256값의 앞 16자리를 iv로 사용
    const iv = sha256Value.substring(0, 16);

    const keyUtf8 = CryptoJS.enc.Utf8.parse(key);
    const ivUtf8 = CryptoJS.enc.Utf8.parse(iv);

    const decrypted = CryptoJS.AES.decrypt(cipherText, keyUtf8, {
      iv: ivUtf8,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7 // Pkcs7은 Pkcs5와 동일한 패딩입니다
    });

    return decrypted.toString(CryptoJS.enc.Utf8); // 평문 문자열
  }
}

const encryptionUtil = new EncryptionUtil();
export default encryptionUtil;
